import { render, staticRenderFns } from "./LocationWorld.vue?vue&type=template&id=3272c817&"
import script from "./LocationWorld.vue?vue&type=script&lang=js&"
export * from "./LocationWorld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports